import React, { useState } from "react";

const Page13 = () => {
  const steps = [
    { title: "CEPRAM nº 4.578", content: "Define requisitos legais para o gerenciamento de riscos em instalações industriais. Essa norma pode ser atualizada ao longo do tempo e define a obrigação legal de avaliar e controlar riscos que possam impactar a segurança, o meio ambiente e a operação." },
    { title: "Programa de Gerenciamento de Riscos (PGR)", content: "Organiza como os riscos são identificados, avaliados e controlados nas operações. No PGR, o MOC entra como o mecanismo que assegura que qualquer alteração seja incorporada a essa gestão, evitando que o cenário de risco fique desatualizado." },
    { title: "Process Management Framework (PMF)", content: "Garante uma aplicação consistente, utiliza-se o Process Management Framework (PMF), que define como são documentados e como os registros são mantidos ao longo do tempo." }    
  ];

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="moc-page">
      {/* ESQUERDA */}
      <div className="moc-left"  style={{paddingTop: '160px'}}>
        <p style={{fontSize: '18px'}}>O MOC vai além de uma diretriz interna: ele está ligado a exigências legais e a práticas estruturadas de gestão de riscos. Na Bahia, a Resolução CEPRAM nº 4.578 define esses requisitos, aplicados por meio do PGR e sustentados pelo PMF. Explore como esses elementos se conectam:</p>
        {steps.map((step, index) => (
          <div
            key={index}
            className={`moc-item ${selectedIndex === index ? "active" : ""}`}
            onClick={() => setSelectedIndex(index)}
          >
            <div className="moc-number">{index + 1}</div>
            <div className="moc-title" style={{fontSize: '16px'}}>{step.title}</div>
            <div className="moc-plus">+</div>
          </div>
        ))}
      </div>

      {/* DIREITA */}
      <div className="moc-right"  style={{paddingTop: '160px'}}>
        <h2>
          {selectedIndex + 1}. {steps[selectedIndex].title}
        </h2>
        <p style={{fontSize: '18px'}}>{steps[selectedIndex].content}</p>
      </div>

      <style>{`

        .container{
          width: 100% !important;
        }


        /* ROOT DA PÁGINA */
        .moc-page {
          display: flex;
          height: 100%;
          overflow: hidden;
        }

        /* COLUNA ESQUERDA */
        .moc-left {
          width: 50%;
          background: #f1f5f9;
          padding: 30px;
          box-sizing: border-box;

          display: flex;
          flex-direction: column;
          gap: 10px;

          overflow-y: auto;
        }

        /* COLUNA DIREITA */
        .moc-right {
          width: 50%;
          background: #4592C5;
          color: white;
          padding: 40px;
          box-sizing: border-box;

          overflow-y: auto;
        }

        /* ITEM */
        .moc-item {
          display: flex;
          align-items: center;
          background: #d9e2ec;
          border-radius: 25px;
          padding: 12px 15px;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .moc-item:hover {
          background: #cbd5e1;
        }

        .moc-item.active {
          background: #93c5fd;
        }

        .moc-number {
          background: #3b82f6;
          color: white;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          font-weight: bold;
        }

        .moc-title {
          flex: 1;
          font-size: 14px;
        }

        .moc-plus {
          font-size: 18px;
          font-weight: bold;
          color: #3b82f6;
        }

        /* TEXTO DIREITA */
        .moc-right h2 {
          margin-bottom: 20px;
        }

        .moc-right p {
          white-space: pre-line;
          line-height: 1.6;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .moc-page {
            flex-direction: column;
            /* height: calc(100vh - 80px);*/
          }

          .moc-left {
            width: 100%;
            height: 40%;
            padding: 20px;
          }

          .moc-right {
            width: 100%;
            height: 60%;
            padding: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default Page13;